import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getLineType = (lineTypeId: number | undefined): Promise<IGetLineType> => {
  return axiosDefaultApi.get(`/api/LineTypes/GetLineTypeViaID/${lineTypeId}`);
};

type QueryFnType = typeof getLineType;

type UseGetLineTypeOptions = {
  lineTypeId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLineType = ({ lineTypeId , config }: UseGetLineTypeOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getLineType_${lineTypeId}`],
    queryFn: () => getLineType(lineTypeId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση του Είδους Γραμμής`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};